import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Booking from 'models/booking';
import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import Brand from 'models/brand';
import { Location } from 'models/locations';

import PricingCode from 'components/parking-passes/validation-section/pricing-code';
import PartnerNotice from 'components/parking-passes/validation-section/partner-notice';
import CurrencySymbol from 'components/common/currency-symbol';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
};

class PassInfoSection extends React.Component {
  static renderedAttribute(attributeValue, attributeText) {
    if (attributeValue) {
      return (
        <div>
          <h5 className="h5-sg without-vertical-margin line-height-extra">
            {attributeText}
          </h5>
          <p>
            {attributeValue}
          </p>
        </div>
      );
    }

    return null;
  }

  validationVehicles() {
    const { parkingPass } = this.props;
    let addOns;
    if (parkingPass) {
      addOns = parkingPass.get('addOns');
    }
    let vehicleSize;
    if (addOns) {
      vehicleSize = addOns.get('vehicleSize');
    }
    let vehicles;
    if (vehicleSize && vehicleSize.length !== 0) {
      vehicles = vehicleSize.first();
    }
    if (vehicles) {
      return vehicles.items.join(', ');
    }
    return null;
  }

  validationPrepaidServices() {
    const { parkingPass } = this.props;
    let addOns;
    if (parkingPass) {
      addOns = parkingPass.get('addOns');
    }
    let generalAddOns;
    if (addOns) {
      generalAddOns = addOns.get('general');
    }
    let prepaidList;
    if (generalAddOns && generalAddOns.length !== 0) {
      prepaidList = generalAddOns.map(generalAddOn => generalAddOn.get('name'));
    }
    if (prepaidList) {
      if (prepaidList.size === 0) {
        return null;
      } else { // eslint-disable-line no-else-return
        return prepaidList;
      }
    }
    return null;
  }

  validationPassValue() {
    const { booking, location, parkingPass } = this.props;
    const passValue = booking.passValue;

    if (passValue && parkingPass.showPassValue) {
      return (
        <Fragment>
          <CurrencySymbol location={location} />
          { parseFloat(passValue).toFixed(2) }
        </Fragment>
      );
    }

    return null;
  }

  render() {
    const { parkingPass, brand } = this.props;

    return (
      <div>
        <h5 className="h5-sg without-vertical-margin vertical-padding-top-2x line-height-extra sm-align-center">
          <FormattedMessage
            id="common.pass-number"
            defaultMessage="PARKING PASS #"
          />
        </h5>
        <h2 className="h2-sg without-vertical-margin sm-align-center">
          {parkingPass.id}
        </h2>
        <PricingCode parkingPass={parkingPass} />
        <hr className="dashed-thin-line visible-lte-sm hidden-print" />
        <PartnerNotice
          brand={brand}
          lowerContentPresent={!!(
            this.validationVehicles() || this.validationPrepaidServices() || this.validationPassValue()
          )}
        />
        {PassInfoSection.renderedAttribute(
          this.validationVehicles(),
          <FormattedMessage id="parking-pass.vehicle-type" defaultMessage="VEHICLE TYPE" />,
        )}
        {PassInfoSection.renderedAttribute(
          this.validationPrepaidServices(),
          <FormattedMessage id="parking-pass.prepaid-services" defaultMessage="PREPAID SERVICES" />,
        )}
        {PassInfoSection.renderedAttribute(
          this.validationPassValue(),
          <FormattedMessage id="parking-pass.pass-value" defaultMessage="PASS VALUE" />,
        )}
      </div>
    );
  }
}

PassInfoSection.propTypes = propTypes;

export default PassInfoSection;
